<template>
  <v-container
    grid-list-xl
    fluid
  >
    <LoadingState
      :loading="loading"
      color="primary"
    />
    <v-layout
      v-if="!loading"
      row
      wrap
    >
      <v-flex
        xs12
      >
        <RoleDetails :role="role" />
        <RolePermissions :role="role" />
        <RoleUsers :role="role" />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import RoleDetails from './RoleDetails'
import RolePermissions from './RolePermissions'
import RoleUsers from './RoleUsers'
import LoadingState from '@/components/LoadingState'

export default {
  name: 'RoleSingle',
  components: {
    LoadingState,
    RoleDetails,
    RolePermissions,
    RoleUsers
  },

  props: {
    role: {
      type: Object,
      required: true
    }
  },

  computed: {
    loading () {
      return Object.entries(this.role).length === 0
    },

    title () {
      return (
        this.role && `${this.role.name}`
      )
    },

    disabled () {
      return this.role.inProgress || !this.role.isChanged
    }
  }
}
</script>
